import { jsx } from 'react/jsx-runtime';
import { mergeProps } from '@zag-js/react';
import { ark } from '../factory.mjs';
import { forwardRef } from '../forward-ref.mjs';
import { runIfFn } from '../run-if-fn.mjs';
import { useAccordionContext } from './accordion-context.mjs';
import { AccordionItemProvider } from './accordion-item-context.mjs';

const AccordionItem = forwardRef((props, ref) => {
  const { value, disabled, children, ...rest } = props;
  const { getItemProps, getItemState } = useAccordionContext();
  const itemState = getItemState({ value });
  const mergedProps = mergeProps(getItemProps({ value, disabled }), rest);
  const view = runIfFn(children, itemState);
  return /* @__PURE__ */ jsx(AccordionItemProvider, { value: { value, disabled, ...itemState }, children: /* @__PURE__ */ jsx(ark.div, { ...mergedProps, ref, children: view }) });
});

export { AccordionItem };
